module.exports = __webpack_public_path__ + "static/the-new-toys-cover-120d30ed58b0a540b8d7edeaeb28603f.png";